import type { ProgressBucket, ProgressRange, StatsRole } from '../types'

export const MISSING_STAT = '–'

export const PROGRESS_RANGES: ProgressRange[] = ['1m', '12w', '6m', '1y', 'all']

export const RANGE_LABELS: Record<ProgressRange, string> = {
  '1m': '1M',
  '12w': '3M',
  '6m': '6M',
  '1y': '1Y',
  all: 'All',
}

export const DEFAULT_RANGE: ProgressRange = '12w'

/** All Sports chart heading, by the period one bar covers. */
export const GAMES_PER_BUCKET_TITLE: Record<ProgressBucket, string> = {
  day: 'Games Played Per Day',
  week: 'Games Played Per Week',
  month: 'Games Played Per Month',
}

export const CARD_STATS: Record<StatsRole, string[]> = {
  skater: ['G', 'A', 'P'],
  goalie: ['SV%', 'SV', 'GA'],
}

/** Career row: how many stats follow the card stats (the row scrolls). */
export const CAREER_EXTRA_STATS = 4

/**
 * The This Week radar takes its spokes from the stats the API sends, so every
 * sport works. More than this crowds the labels.
 */
export const RADAR_MAX_SPOKES = 6

/** Fewer spokes than this draw a line, not a shape — no radar. */
export const RADAR_MIN_SPOKES = 3

export const GAMES_PLAYED_ABBRS = ['GP', 'MP']

// 'GAMES' = whichever of GP/MP is present
export const RATE_FORMULAS: Record<
  string,
  { numerator: string; denominator: string }
> = {
  'PTS/G': { numerator: 'P', denominator: 'GAMES' },
  'SV%': { numerator: 'SV', denominator: 'SA' },
  GAA: { numerator: 'GA', denominator: 'GAMES' },
}

// derived by the API but with no '%' or '/' in the abbr and no rebuild formula
export const DERIVED_STAT_ABBRS = ['GFA']

export const LOWER_IS_BETTER = ['GAA', 'GA', 'L', 'PiM']

export const ALL_SPORTS = 'all'

/**
 * Most stats charted at once — one per line colour, so two selected stats
 * never share one. Unselected chips are disabled at the limit.
 */
export const MAX_SELECTED_STATS = 8

/**
 * Stats charted before any pick: the first chip plus the most active others
 * (`pickDefaultStats`).
 */
export const DEFAULT_SELECTED_STATS = 3

/** Recent games shown before "View More"; the rest open below on demand. */
export const RECENT_GAMES_VISIBLE = 10
